// src/pages/BundeslandBayern.jsx
import React from "react";
import BundeslandPage from "./BundeslandPage";
import { bayern } from "../components/states/bayern";

export default function BundeslandBayern() {
  return <BundeslandPage data={bayern} />;
}

